import { render } from "./Purchase.vue?vue&type=template&id=1e1c7a3b&scoped=true"
import script from "./Purchase.vue?vue&type=script&lang=js"
export * from "./Purchase.vue?vue&type=script&lang=js"

import "./Purchase.vue?vue&type=style&index=0&id=1e1c7a3b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e1c7a3b"]])

export default __exports__